// removed by extract-text-webpack-plugin
module.exports = {"container":"Layout__container__1g5KG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.css
// module id = 64
// module chunks = 3